export default function Nav() {
  return (
    <header className="nav">
      <div className="nav-inner">
        <a className="brand" href="#top">
          <span className="brand-mark" aria-hidden />
          <span>
            Northwind <span className="brand-name">Atlas</span>
          </span>
        </a>
        <nav className="nav-links" aria-label="Primary">
          <a href="#services">Services</a>
          <a href="#metrics">Results</a>
          <a href="#pricing">Pricing</a>
          <a href="#contact" className="btn btn-primary btn-small">
            Get in touch
          </a>
        </nav>
      </div>
    </header>
  );
}
